import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";
/* This is the custom StimulusReflex controller for the Conge Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
    /*
     * Regular Stimulus lifecycle methods
     * Learn more at: https://stimulusjs.org/reference/lifecycle-callbacks
     *
     * If you intend to use this controller as a regular stimulus controller as well,
     * make sure any Stimulus lifecycle methods overridden in ApplicationController call super.
     *
     * Important:
     * By default, StimulusReflex overrides the -connect- method so make sure you
     * call super if you intend to do anything else when this controller connects.
     */
    static targets = ["hm0_output"];

    connect() {
        console.log("FacturesSousTraitants JS en cours ...");
        super.connect();
        // add your code here, if applicable


        if (
            $("#partial-facture-sous-traitant-content").length &&
            $("#partial-facture-sous-traitant-content").text().search(/Chargement en cours/i) > -1
        ) {
            //on est sur le show
            setTimeout(() => this.commandes_soustraitant_hm_ajax_facture_sous_traitant(), 300);
        }




        if ($("#search").length && $("#quick_sort").length) {

            //on est sur la vue list
            this.rerender();
            (function ($) {
                $.each(["show", "hide"], function (i, ev) {
                    var el = $.fn[ev];
                    $.fn[ev] = function () {
                        this.trigger(ev);
                        return el.apply(this, arguments);
                    };
                });
            })(jQuery);
            $("#spinner").on("show", function () {
                $("#total_entries").hide();
            });
            $("#spinner").on("hide", function () {
                $("#total_entries").show();
            });
            $("#filterrific_with_entreprise_raison_sociale").on("input", function() {
                $("#target_entreprise_raison_sociale").val(
                    $("#filterrific_with_entreprise_raison_sociale").val()
                );
            });
            var targetElement = document.getElementById("mySidebar");
            targetElement.addEventListener("scroll", (event) => {
                var element = document.getElementById("mySidebar");
                console.log("From commandes_soustraitant_controller.js =======> ", element.scrollTop);
                document.getElementById("scrollevel").value = element.scrollTop;
            });
                const currentUrl = window.location.href;
                const url = new URL(currentUrl);
                const bonsDeCommandeParam = url.searchParams.get("previous_record");

                if (bonsDeCommandeParam != null) {
                    var trElement = $("#factures_sous_traitant_" + bonsDeCommandeParam);
                    $("#factures_sous_traitant_" + bonsDeCommandeParam + " td").addClass("highlighted-td");
                    $("#factures_sous_traitant_" + bonsDeCommandeParam).get(0).scrollIntoView({ behavior: "smooth", block: "center" });
                }
        }

    }

       //factures-sous-traitant
       commandes_soustraitant_hm_ajax_facture_sous_traitant() {

           if (this.current_app && this.commandes_soustraitant_id) {
               let url =
                   window.location.origin +
                   "/" +
                   this.current_app +
                   "/commandes_soustraitants/show_ajax_for_hm_factures_sous_traitants?commandes_soustraitant_id=" +
                   this.commandes_soustraitant_id +
                   "&vr2=1";
               fetch(url).then((response) =>
                   response.text().then(function (text) {
                   console.log(text);
                       $("#partial-facture-sous-traitant-content").html("");
                       $("#partial-facture-sous-traitant-content").html(text);
                   })
               );
           }
       }

    get current_app() {
        return this.data.get("app");
    }

    get params() {
        return this.data.get("params");
    }

    get commandes_soustraitant_id() {
        return this.data.get("commandes_soustraitant_id");
    }

    get url_solution() {
        return this.data.get("urlsolution");
    }
}
